import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {UserRolesPage} from "./-page/user-roles.page";
import {UserRolesPending} from "./-page/user-roles.pending";

export const Route = createFileRoute("/_app/user-management/users/$userId/roles/")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  pendingComponent: UserRolesPending,
});

function RouteComponent() {
  const {userId} = Route.useParams();

  return <UserRolesPage key={userId} userId={userId} />;
}
